export const REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES =
  'assignees'

export const REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT =
  'isComment'

export const REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT = 'comment'
